"use client";

import ListIcon from '@/components/illustratores/ListIcon';
import Button from '@/components/ui/Button';
import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useItineraryMapStore } from "@/core/stores/itinerary";
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { useItinerarySettingsStore } from '@/core/stores/itinerary/settings';
import { useUserStore } from '@/core/stores/user';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import useSizeController from '@/hooks/useSizeController';
import { faBed } from '@fortawesome/pro-regular-svg-icons/faBed';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import { faLocationPin } from '@fortawesome/pro-regular-svg-icons/faLocationPin';
import { faMapLocationDot } from '@fortawesome/pro-regular-svg-icons/faMapLocationDot';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Image from "next/image";
import { usePathname } from 'next/navigation';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
const HotelModal = dynamic(() => import('./HotelModal'))
const MapOptions = dynamic(() => import('./MapOptions'))
const ModalOfMarker = dynamic(() => import("./modalOfMarker"))
const GroupChat = dynamic(() => import("./groupChat/GroupChat"))

const staggerContainer = {
    show: {
        transition: {
            staggerChildren: 0.2, // Adjust the delay between children animations
        },
    },
};

const item = {
    hidden: { opacity: 0, x: 50 }, // Start from right
    show: { opacity: 1, x: 0 },     // Animate to the final position
    exit: { opacity: 0, x: 50 },    // Exit back to the right
};

export default function MapOverlay({ assetUrl, baseUrl, clientToken, userToken }: { assetUrl: string; baseUrl: string; clientToken: string, userToken?: string }) {
    const NEXT_PUBLIC_STORAGE_URL = process.env.NEXT_PUBLIC_STORAGE_URL;

    const { activityModal, setActivityModal, modalData, setModalData, setShowPlaceDetail,
        setHotelDetail, hotelDetail, hotels, setShowHotels, showHotels, isLoadingPlace } = useItineraryMapStore();
    const { _id } = useUserStore()

    const { setShowGroupChat, showGroupChat, setShowMap, showMap } = useItinerarySettingsStore()

    const { itinerary, itineraryDays, itineraryId } = useItineraryStoreV2()

    const [cityError, setCityError] = useState(false);

    const [selectedLocation, setSelectedLocation] = useState({
        name: "",
        id: "",
        country: "",
    });

    const [showDays, setShowDays] = useState(false);


    const { isSmall, innerWidth } = useSizeController()


    const ref = useOutsideClick(() => {
        // setShowDays(false)
    });

    const [showSearch, setShowSearch] = useState(false)

    const pathname = usePathname()

    const { setShowAuthModal } = useAuthenticationModalStore()
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
        if (typeof window !== 'undefined' && document) {
            setIsReady(true)
        }
    }, [])

    if (!isReady) {
        return null;
    }

    return (
        <div className='overflow-hidden max-h-full max-w-full '>
            <AnimatePresence>
                {itineraryDays && itineraryDays?.length > 0 && !showGroupChat && !modalData && (
                    <motion.div
                        initial={{ x: 100, opacity: 1 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ type: "spring", stiffness: 80, }}
                        onClick={() => {
                            if (!_id) {
                                setShowAuthModal(true)
                                return
                            }
                            setModalData(null)
                            setShowGroupChat(true)
                        }}
                        className='fixed z-[100] bottom-4 right-4 md:bottom-12 md:right-12 w-fit'
                    >
                        <Image
                            src={NEXT_PUBLIC_STORAGE_URL + 'assets/83cba617-bd82-4da1-b664-c5211694f815-planingo.png'}
                            width={500}
                            className='size-20 pulse shadow-xl cursor-pointer rounded-full'
                            height={400}
                            alt='itinerary'
                        />
                    </motion.div>
                )}
            </AnimatePresence>
            {/* <div className='absolute md:hidden min-w-[250px] z-10 left-4 top-4 flex items-center'>
                <LocationInput baseUrl={baseUrl} searchedCity={''}
                    cityError={cityError}
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                />
            </div> */}
            {pathname !== '/itineraries/generate' && <button onClick={() => {
                setModalData(null)
                setHotelDetail(null)
                setActivityModal(null)
                setShowPlaceDetail(null)
                setShowMap(!showMap)
            }}
                className='absolute right-1/2   z-40 translate-x-1/2 bottom-8 transition-transform duration-300 
                            flex md:hidden'
            >
                <Button color='secondary' radius='rounded-full'
                    className='flex z-50 min-w-fit relative items-center justify-center'
                >
                    {!showMap ? <>

                        <FontAwesomeIcon icon={faMapLocationDot} className='text-white' size="lg" />
                        <span>Map</span>
                    </> :
                        <>
                            <ListIcon className='w-4' />
                            <span className='min-w-fit text-nowrap'>View List</span>
                        </>
                    }
                </Button>
            </button>}

            {createPortal(
                <AnimatePresence>
                    {!showGroupChat && !modalData && (showMap || !isSmall) && (
                        <motion.div
                            initial="hidden"
                            animate="show"
                            exit="hidden"
                            variants={staggerContainer}
                            className="absolute pr-4 right-0  top-4 flex z-[1000] flex-col gap-4"
                        >
                            {/* <motion.div
                                variants={item}
                                onClick={() => {
                                    setShowSearch(s => !s);
                                    setShowMap(false);
                                }}
                                className="md:flex hidden relative h-10 w-10 mx-auto mr-0 cursor-pointer justify-center items-center gap-2 rounded-lg bg-indigo-500 p-2 text-sm text-white"
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </motion.div>

                            <motion.div
                                variants={item}
                                className="md:flex gap-1 absolute z-50 right-full -translate-x-2 hidden w-full min-w-[220px] sm:w-[300px]"
                            >
                                <AnimatePresence>
                                    {showSearch && (
                                        <motion.div
                                            initial={{ opacity: 0, x: 50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0, x: 50 }}
                                            className="overflow-visible w-full"
                                        >
                                            <LocationInput
                                                baseUrl={baseUrl}
                                                searchedCity={''}
                                                cityError={cityError}
                                                selectedLocation={selectedLocation}
                                                setSelectedLocation={setSelectedLocation}
                                            />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </motion.div> */}

                            <motion.div variants={item} className="relative">
                                {(
                                    <div
                                        onClick={() => setShowDays((s) => !s)}
                                        className={`${showDays ? 'bg-secondary-500 text-white' : 'bg-white text-gray-600'}
                                                     flex h-10 w-10 mx-auto mr-0 cursor-pointer justify-center items-center gap-2
                                                      rounded-2xl shadow-md  p-2`}
                                    >
                                        <FontAwesomeIcon className='flex items-center justify-center' icon={faLayerGroup} />
                                    </div>
                                )}
                                <MapOptions setShowDays={setShowDays} showDays={showDays} />
                            </motion.div>

                            {/* <motion.div variants={item}>
                                <CurrentLocationButton />
                            </motion.div> */}
                        </motion.div>
                    )}
                </AnimatePresence>,
                window.document.body
            )}
            <div className={`bottom-8 flex-col gap-2 absolute z-10 right-6 flex`}>
                <div className="relative hidden" ref={ref}>
                    {itineraryDays.length > 0 && (
                        <div
                            onClick={() => setShowDays((s) => !s)}
                            className="flex h-fit w-12 aspect-square justify-center mx-auto mr-0 cursor-pointer items-center gap-2 rounded-lg bg-[#333333] p-2 text-sm text-white"
                        >
                            <FontAwesomeIcon icon={faLayerGroup} className='w-7' />
                        </div>
                    )}
                    <MapOptions setShowDays={setShowDays} showDays={showDays} />
                </div>
                <div className="relative hidden">
                    {hotels.length > 0 && (
                        <div
                            onClick={() => setShowHotels(!showHotels)}
                            className={`${showHotels ? 'bg-indigo-600 text-white' : 'text-white bg-[#333333]'}  h-fit w-12 aspect-square flex items-center justify-center mx-auto mr-0 cursor-pointer rounded-lg  p-2 text-sm `}
                        >
                            <FontAwesomeIcon className='w-7' icon={faBed} />
                        </div>
                    )}
                </div>
                {/* {settings?.hasAccess && itineraryDays.length > 0 &&
                    <div className='md:flex flex-col gap-2 relative hidden'>
                        {!unReadMessage && <div className="w-5 h-5 text-xs text-white flex justify-center items-center bg-red-500 rounded-full absolute -top-2 -left-2 shadow-md">1</div>}
                        <button onClick={() => {
                            setShowChatBot(!showChatBot)
                            setReadMessage(true)
                        }} className={`relative w-[54px] h-[54px] justify-center aspect-square text-white flex items-center gap-2 rounded-full`}>
                            <Image src={`${wpAssetUrl}/2024/08/chatbot-icon.png`} alt="Ai chatbot icon" width={100} height={100} className="w-full h-full" />
                            <Lottie className='w-[54px] absolute' animationData={aiChatAnimation} loop={true} />
                        </button>
                    </div>
                } */}
            </div>

            {/* <ModalOfMarker
                googleKey={googleKey}
                showModal={!!modalData}
                onClose={() => setModalData(null)}
                placeData={modalData as ItineraryItem}
            /> */}


            {/* 
            <ActivityModal showModal={!!activityModal} placeData={activityModal}
                googleKey={googleKey} onClose={() => setActivityModal(null)} /> */}

            {
                hotelDetail &&
                <HotelModal
                    showModal={!!hotelDetail}
                    onClose={() => setHotelDetail(null)}
                    placeData={hotelDetail}
                    itineraryId={itineraryId!}
                />

            }

            <AnimatePresence>
                {showGroupChat && !modalData &&
                    <motion.div
                        initial={{ x: '100%' }}
                        animate={{ x: '0' }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'spring', damping: 20, duration: 0.2 }}
                        className={`absolute top-0 right-0 z-50 ${innerWidth < 760 && 'left-0'}`}>
                        <GroupChat assetUrl={assetUrl} baseUrl={baseUrl} userToken={userToken!} showCloseButton />
                    </motion.div>
                }
            </AnimatePresence>

            <AnimatePresence>
                {modalData &&
                    <motion.div
                        initial={{ x: '100%' }}
                        animate={{ x: '0' }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'spring', damping: 20, duration: 0.2 }}
                        className={`absolute top-0 right-0 z-50 ${innerWidth < 760 && 'left-0'}`}>
                        <ModalOfMarker placeData={modalData}
                            onClose={() => { setModalData(null) }}
                            showModal={!!modalData} />
                    </motion.div>
                }
            </AnimatePresence>
        </div >
    )
}


// const CurrentLocationButton = ({ center }: { center?: google.maps.LatLngLiteral }) => {
//     const { setUserPin, setZoomTo, selectMode, setSelectMode, city } = useItineraryMapStore()

//     const [isCurrentLocation, setIsCurrentLocation] = useState(false)

//     const { setSearchParam, params } = useSetSearchParams()
//     const handleGetLocation = () => {
//         city?.lat && city.lng && setZoomTo({ lat: city?.lat, lng: city?.lng })
//         setSelectMode(!selectMode)
//     };



//     const [isGettingNearbies, setIsGettingNearBies] = useState<string | null>(null)

//     const { setNearBys, setNearByHotels, userPin, searchRadios } = useItineraryMapStore()

//     const nearbyRef = useOutsideClick(() => setSelectMode(false))

//     const getNearbyHotels = async () => {
//         if (!userPin || !searchRadios) {
//             return
//         }
//         setIsGettingNearBies('hotels')
//         const res = await avalibilityByGeo({
//             lat: userPin.lat.toString(),
//             lng: userPin.lng.toString(),
//             limit: 40,
//             radius: (searchRadios / 1000).toFixed(2),
//         })
//         const { result, response } = JSON.parse(res)
//         if (response.ok) {
//             setNearByHotels(result.hotels)

//         }
//         setIsGettingNearBies(null)
//     }

//     const getNearbies = async (type: string) => {
//         if (!userPin || !searchRadios) {
//             return
//         }
//         setIsGettingNearBies(type)
//         const res = await getNearBies({
//             lat: String(userPin?.lat), lng: String(userPin.lng),
//             types: type,
//             limit: '20',
//             radios: searchRadios.toString(),
//             keyword: type
//         })
//         const { result } = await JSON.parse(res)
//         result && setNearBys(result)
//         setIsGettingNearBies(null)
//     }

//     return <button
//         ref={nearbyRef}
//         onClick={handleGetLocation}
//         className={`${selectMode ? ' text-white bg-[#333333]' : 'text-white bg-indigo-500'}
//                     aspect-square  flex  shadow-md h-10 w-10  mx-auto mr-0 
//                      cursor-pointer justify-center relative items-center gap-2 rounded-lg border border-white p-2 text-sm `}>

//         <IconCurrentLocation className='w-5' />

//         <AnimatePresence>
//             {selectMode && <motion.div
//                 initial={{ opacity: 0, x: 0 }}
//                 exit={{ opacity: 0, x: 0 }}
//                 animate={{ opacity: 100, x: -10 }}
//                 className='text-xs shadow-cyan-200 z-[1000] absolute w-max right-full top-0  
//                           bg-white flex flex-col gap-2 p-2 shadow rounded-lg text-center'>

//                 <div
//                     className='font-semibold text-gray-500'>
//                     Radius: {searchRadios?.toFixed(0)} m
//                 </div>

//                 <button onClick={(e) => {
//                     e.stopPropagation()
//                     getNearbies('restaurant')
//                 }}
//                     className='hover:bg-orange-600 rounded-md w-full text-center bg-orange-500 text-white py-1'>
//                     {isGettingNearbies === 'restaurant' ? <div role="status">
//                         <svg aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin  fill-orange-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
//                             <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
//                         </svg>
//                         <span className="sr-only">Loading...</span>
//                     </div> : 'Restaurants'

//                     }
//                 </button>
//                 <button onClick={(e) => {
//                     e.stopPropagation()
//                     getNearbies('tourist_attraction')
//                 }}
//                     className='hover:bg-indigo-600 rounded-md w-full text-center bg-indigo-500 text-white py-1'>
//                     {isGettingNearbies === 'tourist_attraction' ? <div role="status">
//                         <svg aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin  fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
//                             <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
//                         </svg>
//                         <span className="sr-only">Loading...</span>
//                     </div> : 'Activities'}
//                 </button>
//             </motion.div>}
//         </AnimatePresence>
//     </button>
// }


interface LocationInputProps {
    baseUrl: string
    cityError: boolean;
    searchedCity: string;
    selectedLocation: {
        name: string;
        id: string;
        country: string;
    },
    setSelectedLocation: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
}

const LocationInput = ({ selectedLocation, setSelectedLocation, searchedCity, cityError, baseUrl, }: LocationInputProps) => {
    const [isGettingCities, setIsGettingCities] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [errors, setErrors] = useState({
        city: "",
        date: "",
        passenger: "",
    });

    const { setUserPin, setShowPlaceDetail, setIsLoadingPlace, } = useItineraryMapStore()
    const { itinerary } = useItineraryStoreV2()
    const [city, setCity] = useState("");
    const [showCities, setShowCities] = useState(false);

    const [predictions, setPredictions] = useState<
        { id: string; name: string }[]
    >([]);

    const { innerWidth, isSmall } = useSizeController()

    const cityModal = useOutsideClick(() => {
        innerWidth > 1024 && setShowCities(false);
    });

    useEffect(() => {
        const get = async (city: string) => {
            setIsGettingCities(true);
            try {
                const res = await fetch(`${baseUrl}/places/auto-complete/map?input=${city}&lat=${itinerary?.cityLat}&lng=${itinerary?.cityLng}&radius=5000`);

                const { predictions } = await res.json();

                const cityNames = predictions?.map(
                    (prediction: any) => {
                        return {
                            name: prediction.description,
                            id: prediction.place_id,
                        };
                    },
                );
                setIsGettingCities(false);
                setPredictions(cityNames || []);
            } catch (err) {
                setIsGettingCities(false);
                console.log("Error is triggered", JSON.stringify(err));

                setFetchError("Something went wrong!");
            }
        };
        setFetchError("");

        if (city) {
            setIsGettingCities(true);
        }
        const getData = setTimeout(() => {
            get(city);
        }, 300);

        return () => clearTimeout(getData);
    }, [city, searchedCity]);

    const getPlace = async (id: string) => {
        // setIsGettingPlace(true)
        setShowPlaceDetail(null)
        setIsLoadingPlace(true)
        const res = await fetch(`/api/places/details?placeId=${id}`)

        const { result, response } = await res.json()

        if (!result.error) {
            setShowPlaceDetail(result)
        }
        setIsLoadingPlace(false)
        // setIsGettingPlace(false)
    }

    const ref = useOutsideClick(() => {
        setShowCities(false)
    })

    return <div className='relative w-full overflow-visible'>
        <div ref={ref} className='relative  mr-2'>
            <button >
                <FontAwesomeIcon
                    className='absolute w-5 z-20 text-neutral-700 top-1/2 -translate-y-1/2 left-2'
                    icon={faSearch} />
            </button>
            <input
                ref={cityModal}
                placeholder={`Search in ${searchedCity}`}
                value={
                    city
                }
                className={`${errors.city ? "border-rose-500" : "border"}
                    shadow peer relative w-full border-gray-300 rounded-xl border bg-slate-50 p-2 py-2  
                     placeholder:text-gray-400 text-neutral-600 placeholder:text-sm pl-8
  `}
                onChange={async (e) => {
                    setCity(e.target.value);
                    setSelectedLocation({
                        name: "",
                        id: "",
                        country: "",
                    });
                }}
                onClick={() => setShowCities(true)}
                onFocus={() => {
                    setErrors({ ...errors, city: "" });
                    setShowCities(true);
                }}
                type="text"
            />
        </div>

        {
            cityError && (
                <p className="ps-1 pt-1 text-sm font-normal text-red-600">
                    Please choose your destination.
                </p>
            )
        }
        {
            isGettingCities && city.length > 0 ? (
                <div
                    className="absolute translate-y-2 top-full  left-0 z-50  flex  h-fit w-full min-w-fit flex-col
  items-stretch  gap-1 overflow-hidden rounded-lg border bg-white px-2 
  py-2  shadow transition-all duration-300  "
                >
                    <div className="flex w-full flex-col gap-8 pt-1">
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : predictions.length > 0 && city.length > 0 ? (
                <div
                    className={`${showCities
                        ? "pointer-events-auto translate-y-2 opacity-100"
                        : "pointer-events-none translate-y-0 opacity-0"
                        } absolute top-full left-0 z-50  flex  h-fit w-full min-w-fit flex-col items-stretch  gap-1 overflow-hidden rounded-lg border bg-white px-2 py-2 shadow transition-all duration-300`}
                >
                    {predictions?.map((item) => (
                        <div
                            onClick={async () => {
                                setShowCities(false);

                                getPlace(item.id)



                            }}
                            className="group grid cursor-pointer grid-cols-[30px,_1fr] place-items-start items-start gap-1 rounded-xl 
                                        px-1 py-1 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                            key={item.id}
                        >
                            <FontAwesomeIcon
                                icon={faLocationPin}
                                className="w-5 justify-self-center text-gray-500"
                            />
                            <div className="flex flex-col  gap-1">
                                <p className="font-semibold text-[#202020]">
                                    {" "}
                                    {item.name.split(", ")[0]}{" "}
                                </p>
                                <span className="text-xs font-normal text-gray-600">
                                    {item.name.split(", ")[1]}{" "}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                city.length > 0 && (
                    <div
                        className="absolute bottom-0 z-50 hidden h-0 w-full min-w-fit 
  overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all duration-300 
   peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100 lg:flex"
                    >
                        <div
                            className="group flex w-full max-w-full cursor-pointer items-center gap-3 
    transition-colors duration-200 hover:text-emerald-700 "
                        >
                            {fetchError ? (
                                <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                    <p className="text-orange-500">{fetchError}</p>

                                    <Image
                                        className="w-32"
                                        src={"https://assets.bamboo.travel/wrong.svg"}
                                        width={300}
                                        height={300}
                                        alt="Nothing Found"
                                    />
                                </div>
                            ) : (
                                city.length > 0 && (
                                    <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                        <p className='text-neutral-700 text-sm'>nothing was found!</p>

                                        <Image
                                            className="w-20"
                                            src={"https://assets.bamboo.travel/looking.svg"}
                                            width={300}
                                            height={300}
                                            alt="Nothing Found"
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )
            )
        }
    </div>
}

